import React, { useState, useEffect, useCallback } from 'react'; // 1. Added useCallback
import styles from './reviews.module.css';
import { IoPersonCircleOutline } from "react-icons/io5";

const reviews = [
  {
    id: 1,
    name: "Anudeep",
    Profession: "Attendee",
    // image: <IoPersonOutline />,
    Headline: "Inspiring and Enjoyable ",
    text: "I enjoyed TEDx, find it well-produced, and appreciate the quality of talks across topics. This reflects an overall positive perception of the experience."
  },
  {
    id: 2,
    name: "Ananya",
    Profession: "Attendee",
    // image: <IoPersonOutline />,
    Headline: "Great Learning Resource",
    text: "TEDx Talks are useful for learning public speaking, English listening skills, and global perspectives — making them beneficial for students and lifelong learners alike."
  },
  {
    id: 3,
    name: "Revanth",
    Profession: "Team Member",
    // image: <IoPersonOutline />,
    Headline: "As a team, we conclude that the TEDx event effectively delivered its mission of sharing meaningful ideas within the community. Despite minor shortcomings, the event demonstrated strong teamwork, creative vision, and positive audience impact. ",
    text: "As a team, we conclude that the TEDx event successfully fostered meaningful idea-sharing through strong collaboration and engaging presentations. With minor improvements in content depth and interaction, future editions can deliver an even greater impact."
  },
  {
    id: 4,
    name: "Harnika",
    Profession: "Team Member",
    // image: <IoPersonOutline />,
    Headline: "As a team, we believe TEDx fulfilled its purpose of spreading ideas worth sharing. Despite minor areas for improvement, the event demonstrated strong collaboration, thoughtful curation, and meaningful impact on the audience.",
    text: "We consider this TEDx event a successful and enriching experience and recommend continued efforts to further enhance content depth and speaker preparation in future editions."
  }
];

const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [translateValue, setTranslateValue] = useState(0);
  const [transitionStyle, setTransitionStyle] = useState("none");
  const [selectedReview, setSelectedReview] = useState(null);

  // Helper to get review index safely
  const getIndex = (index) => {
    const len = reviews.length;
    return (index + len) % len;
  };

  // ---------------------------
  // SLIDE FUNCTION (Wrapped in useCallback)
  // ---------------------------
  const handleSlide = useCallback((direction) => {
    // We depend on isAnimating and selectedReview here
    if (isAnimating || selectedReview) return; 

    setIsAnimating(true);
    const amount = direction === "next" ? -100 : 100;

    // 1. Apply transition and move
    setTransitionStyle("transform 0.5s ease");
    setTranslateValue(amount);

    // 2. Wait for animation to finish (500ms)
    setTimeout(() => {
      setCurrentIndex((prev) => {
        return direction === "next" 
          ? (prev + 1) % reviews.length 
          : (prev - 1 + reviews.length) % reviews.length;
      });

      // 3. Reset position instantly (no transition)
      setTransitionStyle("none");
      setTranslateValue(0);
      setIsAnimating(false);
    }, 500);
  }, [isAnimating, selectedReview]); // Dependencies for useCallback

  // ---------------------------
  // AUTO SLIDE EFFECT
  // ---------------------------
  useEffect(() => {
    if (selectedReview || isAnimating) return;

    const interval = setInterval(() => {
      handleSlide("next");
    }, 15000);

    return () => clearInterval(interval);
  // currentIndex is not needed here because handleSlide manages state updates internally
  }, [handleSlide, selectedReview, isAnimating]); 


  // Determine current cards
  const mainData = reviews[getIndex(currentIndex)];
  const leftData = reviews[getIndex(currentIndex - 1)];
  const rightData = reviews[getIndex(currentIndex + 1)];

  return (
    <div className={styles.testimonialsection}>
      <div className={styles.headercontent}>
        <h1>Enjoyed by Many</h1>
        <p>Real Stories, Real Bites, Real Love - Hear from Those Who've Tasted the Difference</p>
      </div>

      <div className={styles.carouselcontainer}>
        
        {/* PREV BUTTON */}
        <button className={`${styles.navbtn} ${styles.prevbtn}`} onClick={() => handleSlide("prev")}>
          &#8617; 
        </button>

        {/* LEFT CARD */}
        <div 
          className={`${styles.glasscard} ${styles.sidecard} ${styles.leftcard}`}
          onClick={() => setSelectedReview(leftData)}
          style={{
            transition: transitionStyle,
            transform: `translateX(${translateValue}%) translateY(-50%)`
          }}
        >
          <div className={styles.textinfoside}>
            <h3>{leftData.name}</h3>
            <span>{leftData.Profession}</span>
          </div>
          <div className={styles.contentcut}>
            <p>{leftData.text.substring(0, 40)}...</p>
          </div>
        </div>

        {/* MAIN CARD */}
        <div 
          className={`${styles.glasscard} ${styles.maincard}`}
          onClick={() => setSelectedReview(mainData)}
          style={{
            transition: transitionStyle,
            transform: `translateX(${translateValue}%) scale(1.05)`
          }}
        >
          <div className={styles.profileheader}>
            <div className={styles.textinfo}>
              <h3>{mainData.name}</h3>
              <span>{mainData.Profession}</span>
            </div>
            <IoPersonCircleOutline size={50} />
          </div>
          <div className={styles.reviewText}>
            {/* <p>{mainData.Headline}</p> */}
            <p>{mainData.text}</p>
          </div>
        </div>

        {/* RIGHT CARD */}
        <div 
          className={`${styles.glasscard} ${styles.sidecard} ${styles.rightcard}`}
          onClick={() => setSelectedReview(rightData)}
          style={{
            transition: transitionStyle,
            transform: `translateX(${translateValue}%) translateY(-50%)`
          }}
        >
          <div className={styles.textinfoside}>
            <h3>{rightData.name}</h3>
            <span>{rightData.Profession}</span>
          </div>
          <div className={styles.contentcut}>
           <p>{rightData.text.substring(0, 40)}...</p>
          </div>
        </div>

        {/* NEXT BUTTON */}
        <button className={`${styles.navbtn} ${styles.nextbtn}`} onClick={() => handleSlide("next")}>
          &#8618;
        </button>

      </div>

      {/* POPUP MODAL */}
      {/* {selectedReview && (
        <div className={styles.popupoverlay} style={{ display: 'flex' }} onClick={() => setSelectedReview(null)}>
          <div className={styles.popupbox} onClick={(e) => e.stopPropagation()}> */}
            {/* ❌ CLOSE BUTTON */}
      {/* <button
        className={styles.closeBtn}
        onClick={() => setSelectedReview(null)}
        aria-label="Close"
      >
        ✕
      </button>
            <img src={selectedReview.image} alt="Popup Profile" className={styles.popupimg} />
            <h2 className={styles.popupname}>{selectedReview.name}</h2>
            <h4 className={styles.popuppro}>{selectedReview.Profession}</h4>
            <p className={styles.popuptext}>{selectedReview.text}</p>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default TestimonialCarousel;